const localApiBase = typeof window !== 'undefined'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname)
  ? `http://${window.location.hostname}:5000`
  : '';

export const API_BASE = (process.env.REACT_APP_API_URL || localApiBase).replace(/\/$/, '');
export const LOW_STOCK_THRESHOLD = 5;
